import type { UserNotificationRefs } from '@domain/models/user-notifications/user-notification-refs'

export const UserNotificationType = {
  CommentAdded: 'comment_added',
  CommentLiked: 'comment_liked',
  CommentReplied: 'comment_replied',
  ReplyLiked: 'reply_liked',
  WebinarQuestionLiked: 'webinar_question_liked',
  HackSuggestionSelectedWorks: 'hack_suggestion_selected_works',
  WebinarTopicUpvoted: 'webinar_topic_upvoted',
} as const

export type UserNotificationType =
  (typeof UserNotificationType)[keyof typeof UserNotificationType]

export interface UserNotification {
  uid: string
  title?: string
  description?: string
  createdTime?: Date
  read?: boolean
  readTime?: Date
  activityRef?: string
  supportTicketRef?: string
  userSlug?: string
  notificationType?: UserNotificationType | string
  sender?: string
  commentType?: string
  notificationRefs?: UserNotificationRefs
  likeType?: string
  caregiverNotifType?: string
}
